var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.79601 34.446L8.79599 34.946H9.29601H34.947H35.447V34.446V8.79706V8.29706H34.947H9.29701H8.79703L8.79701 8.79704L8.79601 34.446ZM8.79601 88.5981L8.79599 89.0981H9.29601H34.947H35.447V88.5981V62.9471V62.4471H34.947H9.29701H8.79703L8.79701 62.9471L8.79601 88.5981ZM62.947 34.4471V34.9471H63.447H89.096H89.596V34.4471V8.79706V8.29706H89.096H63.447H62.947V8.79706V34.4471ZM87.456 65.5861H97.147V75.2731H87.456V65.5861ZM86.456 76.2731V85.9601H76.769V76.2731H76.771H86.456ZM76.771 64.5861H76.769V54.899H86.456V64.5861H76.771ZM75.771 65.5861V75.2731H75.769H66.084V65.5861H75.769H75.771ZM75.769 86.9601V96.6471H66.082V86.9601H66.084H75.769ZM65.084 85.9601H65.082H55.397V76.2731H65.084V85.9601ZM65.084 64.5861H55.397V54.899H65.084V64.5861ZM87.458 96.6471V86.9601H97.147V96.6471H87.458ZM1.24701 42.495V0.74707H42.994V42.4941L1.24701 42.495ZM1.24701 96.6471V54.9001H42.994V96.6471H1.24701ZM55.396 42.498V0.74707H97.147V42.4941L55.396 42.498Z",
    fill: "url(#paint0_linear_14_2603)",
    stroke: "url(#paint1_linear_14_2603)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_2603",
    x1: 0.747009,
    y1: 48.6971,
    x2: 97.647,
    y2: 48.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_2603",
    x1: 0.747009,
    y1: 48.6971,
    x2: 97.647,
    y2: 48.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.e20d145ddc325242f349aa44bc919911.svg";
export { ForwardRef as ReactComponent };